export default __webpack_public_path__ + "static/media/outside.0f31abb2.svg";